"use client"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { mediaQueries, sizes } from "ui"
import ButtonWithArrow from "../../common/bit/ButtonWithArrow"
import SwiperOnMobile from "../../SwiperOnMobile/SwiperOnMobile"
import ReportCard, { ReportCardProps } from "./ReportCard"

interface ReportCardsListProps {
  itemsList: ReportCardProps[]
  button?: { links: { url: string; name: string }[] }
}

const StyledButtonWithArrow = styled(ButtonWithArrow)`
  padding: 10px 18px;
  margin-top: ${sizes.baseTriple};
  ${mediaQueries.mobile} {
    margin-top: ${sizes.baseTriple};
  }
  ${mediaQueries.desktopM} {
    padding: ${sizes.baseDouble} ${sizes.baseTriple};
  }
`

const StyledSwiperOnMobile = styled(SwiperOnMobile)`
  width: 100%;
  ${mediaQueries.desktopM} {
    display: flex;
    flex-wrap: wrap;
    gap: ${sizes.baseDouble};
    justify-content: center;
  }
  ${mediaQueries.desktopXl} {
    gap: ${sizes.baseTriple};
  }
`

const ReportCardsList: React.FC<ReportCardsListProps> = ({
  itemsList,
  button,
}) => {
  if (!itemsList?.length) return null
  return (
    <Box>
      <StyledSwiperOnMobile
        swiperProps={{
          spaceBetween: 16,
          slidesPerView: 1.2,
          centeredSlides: false,
        }}
      >
        {itemsList.map((item, index) => (
          <ReportCard key={`report-card-${index}-${item.name}`} data={item} />
        ))}
      </StyledSwiperOnMobile>
      {button && button?.links?.length > 0 && (
        <StyledButtonWithArrow href={button.links[0].url}>
          {button.links[0]?.name}
        </StyledButtonWithArrow>
      )}
    </Box>
  )
}

export default ReportCardsList
